// extracted by mini-css-extract-plugin
export var contactForm = "Subscribe-module--contactForm--7cbd9";
export var contactFormSubmitButton = "Subscribe-module--contactFormSubmitButton--c2b05";
export var subscribeBlock = "Subscribe-module--subscribeBlock--b95bc";